/**
 * ヘッダー全体にクラス名「js-gnav」
 * ヘッダーメニューにクラス名「js-gnav-navbar」
 * ハンバーガーメニューにクラス名「js-gnav-toggle」
 * グローバルメニューにクラス名「js-gnav-menu」
 */

jQuery(function ($) {
	// PC時のナビゲーションの動き
	// ===========================
	// var $win = $(window),
	//     $cloneNav = $('.js-gnav').clone().addClass('js-gnav-clone').appendTo('body'),
	//     showClass = 'is-show';

	// $win.on('load scroll', function() {
	//   var value = $(this).scrollTop();
	// 	if (window.matchMedia('(min-width: 769px)').matches) {
	// 		if ( value > 700 ) {
	// 			$cloneNav.addClass(showClass);
	// 		} else {
	// 			$cloneNav.removeClass(showClass);
	// 		}
	// 	} else {
	// 		if ( value > 280 ) {
	// 			$cloneNav.addClass(showClass);
	// 		} else {
	// 			$cloneNav.removeClass(showClass);
	// 		}
	// 	}
	// });
	$(window).scroll(function () {
		var h = $(this).scrollTop();
		if (h > 700) {
			$('.js-gnav').addClass('is-fixed');
		} else {
			$('.js-gnav').removeClass('is-fixed');
		}

	});

	// スマホメニューの切り替え
	// ===========================
	var gnavWrapperClass = $('.js-gnav'); // ナビゲーション全体を囲んでいるクラス名
	var gnavToggleClass = $('.js-gnav-toggle'); // トグルメニューのクラス名
	var gnavNavClass = $('.js-gnav-nav'); // ナビバーを囲んでいるクラス名
	var activeClass = 'is-active'; // アクティブ時のクラス名

	function SPmenuOpen() {
		gnavWrapperClass.toggleClass(activeClass);

		if ($(gnavWrapperClass).hasClass(activeClass)) {
			gnavToggleClass.addClass(activeClass);
			gnavNavClass.addClass(activeClass);
		} else {
			gnavToggleClass.removeClass(activeClass);
			gnavNavClass.removeClass(activeClass);
		}
	}

	gnavToggleClass.on('click', function () {
		SPmenuOpen();
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.js-gnav-navbar').length && $(gnavWrapperClass).hasClass(activeClass)) {
			SPmenuOpen();
		}
	});

	// ドロップダウンメニュー
	// ===========================
	var gnavMenuClass = $('.js-gnav-menu'); // メニューのクラス
	var gnavSubMenuClass = '.sub-menu'; // サブメニューのクラス
	var gnavHasSubmenuClass = '.menu-item-has-children'; // サブメニューを持っている親クラス

	if (window.matchMedia('(min-width: 769px)').matches) {

		gnavMenuClass.find(gnavHasSubmenuClass).mouseenter(function () {

			$(this).addClass(activeClass);
			return false;

		}).mouseleave(function () {

			$(this).removeClass(activeClass);
			return false;

		});

	} else {

		gnavMenuClass.find(gnavHasSubmenuClass).on('click', function () {
			$(this).toggleClass(activeClass);
		});

		$(gnavHasSubmenuClass).find(gnavSubMenuClass).on('click', function (e) {
			e.stopPropagation();
		});

	}

});
